import React, { Component } from "react";
import { Route } from "react-router-dom";
import HomeReporting from "../HomeReporting";


class Main extends Component {
    render() {
        return (
            <div className="main instand">
                <div className="myContainer">
                    <div className="content">
                        <Route exact path="/" component={HomeReporting} />
                    </div>
                </div>
            </div>
        );
    }
}

export default Main;
